import {
  UserAccount,
  UserIdentity,
  PasskeyCredential,
  UserSession,
  AccountSecurityEvent,
  FinancialScenario,
  UserFavoriteItem,
  GlobalAlert,
  NotificationItem,
  NotificationPreference,
  PrivacyPreference,
  ConsentRecord,
  RbacPermission,
  RoleAssignment,
  AdminAuditLogEntry,
  IdentityTelemetry,
  DeliverableP8,
  YamooPayActivityItem,
} from '../types';

export const INITIAL_MOCK_USER: UserAccount = {
  id: 'usr_yamoo_994821',
  primaryEmail: 'alexandre.dubois@yamoopay.com',
  emailVerified: true,
  emailVerifiedAt: '2026-01-15T10:24:00Z',
  displayName: 'Alexandre Dubois',
  avatarUrl: undefined,
  locale: 'fr-FR',
  regionPreference: 'US-CA',
  timezone: 'America/Los_Angeles',
  defaultCurrency: 'USD',
  status: 'ACTIVE',
  isGuest: false,
  createdAt: '2026-01-15T10:24:00Z',
  updatedAt: '2026-08-24T12:00:00Z',
};

export const INITIAL_MOCK_IDENTITIES: UserIdentity[] = [
  {
    id: 'id_passkey_01',
    userId: 'usr_yamoo_994821',
    provider: 'PASSKEY',
    providerSubject: 'cred_fido_macbook_pro_2026',
    email: 'alexandre.dubois@yamoopay.com',
    linkedAt: '2026-01-15T10:25:00Z',
    lastUsedAt: '2026-08-24T09:12:00Z',
  },
  {
    id: 'id_google_01',
    userId: 'usr_yamoo_994821',
    provider: 'GOOGLE',
    providerSubject: 'google_oidc_sub_1092837482910',
    email: 'alexandre.dubois@yamoopay.com',
    linkedAt: '2026-02-01T14:30:00Z',
    lastUsedAt: '2026-08-10T11:00:00Z',
  },
];

export const INITIAL_MOCK_PASSKEYS: PasskeyCredential[] = [
  {
    id: 'pk_01',
    userId: 'usr_yamoo_994821',
    credentialId: 'cred_fido_macbook_pro_2026',
    name: 'MacBook Pro M3 (Touch ID)',
    publicKeySummary: 'ECDSA_P256_FIDO2_ATT_NONE',
    createdAt: '2026-01-15T10:25:00Z',
    lastUsedAt: '2026-08-24T09:12:00Z',
    transports: ['internal', 'hybrid'],
    status: 'ACTIVE',
  },
  {
    id: 'pk_02',
    userId: 'usr_yamoo_994821',
    credentialId: 'cred_yubikey_5_nfc_work',
    name: 'YubiKey 5 NFC (Backup Hardware Key)',
    publicKeySummary: 'RSA_2048_FIDO2_ATT_DIRECT',
    createdAt: '2026-03-10T16:45:00Z',
    lastUsedAt: '2026-07-15T08:30:00Z',
    transports: ['usb', 'nfc'],
    status: 'ACTIVE',
  },
];

export const INITIAL_MOCK_SESSIONS: UserSession[] = [
  {
    id: 'sess_curr_9918',
    userId: 'usr_yamoo_994821',
    deviceBrowser: 'Chrome 128 on macOS Sequoia (Apple Silicon)',
    ipAddress: '198.51.100.42',
    locationApprox: 'San Francisco, CA, United States',
    createdAt: '2026-08-24T08:00:00Z',
    lastSeenAt: '2026-08-24T14:20:00Z',
    expiresAt: '2026-09-07T08:00:00Z',
    isCurrent: true,
    authenticationLevel: 'STANDARD',
  },
  {
    id: 'sess_mobile_3821',
    userId: 'usr_yamoo_994821',
    deviceBrowser: 'Mobile Safari 18 on iPhone 16 Pro',
    ipAddress: '172.56.21.109',
    locationApprox: 'San Jose, CA, United States',
    createdAt: '2026-08-22T19:15:00Z',
    lastSeenAt: '2026-08-23T22:10:00Z',
    expiresAt: '2026-09-05T19:15:00Z',
    isCurrent: false,
    authenticationLevel: 'STANDARD',
  },
  {
    id: 'sess_laptop_7721',
    userId: 'usr_yamoo_994821',
    deviceBrowser: 'Firefox 130 on Windows 11',
    ipAddress: '192.0.2.14',
    locationApprox: 'Paris, France',
    createdAt: '2026-08-01T11:30:00Z',
    lastSeenAt: '2026-08-05T14:00:00Z',
    expiresAt: '2026-08-29T11:30:00Z',
    isCurrent: false,
    authenticationLevel: 'STANDARD',
  },
];

export const INITIAL_SECURITY_EVENTS: AccountSecurityEvent[] = [
  {
    id: 'evt_sec_01',
    userId: 'usr_yamoo_994821',
    eventType: 'SIGN_IN',
    ip: '198.51.100.42',
    location: 'San Francisco, US',
    timestamp: '2026-08-24T08:00:00Z',
    status: 'SUCCESS',
    details: 'Signed in via Passkey (Touch ID) on macOS Chrome',
  },
  {
    id: 'evt_sec_02',
    userId: 'usr_yamoo_994821',
    eventType: 'PASSKEY_ADDED',
    ip: '198.51.100.42',
    location: 'San Francisco, US',
    timestamp: '2026-03-10T16:45:00Z',
    status: 'SUCCESS',
    details: 'Registered new FIDO2 security key: YubiKey 5 NFC',
  },
  {
    id: 'evt_sec_03',
    userId: 'usr_yamoo_994821',
    eventType: 'SOCIAL_ACCOUNT_LINKED',
    ip: '198.51.100.42',
    location: 'San Francisco, US',
    timestamp: '2026-02-01T14:30:00Z',
    status: 'SUCCESS',
    details: 'Linked Google OpenID Connect account (alexandre.dubois@yamoopay.com)',
  },
];

export const INITIAL_ACTIVITIES: YamooPayActivityItem[] = [
  // TODAY
  {
    id: 'act_01',
    userId: 'usr_yamoo_994821',
    type: 'CURRENCY_CONVERSION',
    category: 'CALCULATIONS',
    title: 'Currency Conversion',
    subtitle: 'USD to EUR',
    resultFormatted: 'USD 500 → EUR 460.50',
    timestamp: '2026-08-27T08:15:00Z',
    timeFormatted: '08:15 AM',
    group: 'TODAY',
    hasDrilldown: false,
    metadata: {
      toolId: 'currency-converter',
      pair: 'USD/EUR',
      amount: 500,
      targetCurrency: 'EUR',
      rate: 0.921,
    },
  },
  {
    id: 'act_02',
    userId: 'usr_yamoo_994821',
    type: 'SALARY_CALCULATION',
    category: 'CALCULATIONS',
    title: 'Salary Calculation',
    subtitle: 'Net pay estimate updated',
    resultFormatted: undefined,
    timestamp: '2026-08-27T06:30:00Z',
    timeFormatted: '06:30 AM',
    group: 'TODAY',
    hasDrilldown: true,
    metadata: {
      toolId: 'salary-engine',
      details: 'California $220,000 W-2 estimate • Net $12,410/mo',
    },
  },
  // YESTERDAY
  {
    id: 'act_03',
    userId: 'usr_yamoo_994821',
    type: 'MORTGAGE_SCENARIO',
    category: 'CALCULATIONS',
    title: 'Mortgage Scenario',
    subtitle: "Scenario '30yr Fixed' saved",
    resultFormatted: undefined,
    timestamp: '2026-08-26T16:20:00Z',
    timeFormatted: '04:20 PM',
    group: 'YESTERDAY',
    hasDrilldown: true,
    metadata: {
      toolId: 'loan-engine',
      scenarioId: 'scen_01_relocation',
      details: '$750,000 Purchase / 20% Down / 6.25% APR',
    },
  },
  {
    id: 'act_04',
    userId: 'usr_yamoo_994821',
    type: 'FX_ALERT_TRIGGERED',
    category: 'ALERTS',
    title: 'FX Alert Triggered',
    subtitle: 'GBP/USD target reached',
    resultFormatted: '1.2500',
    timestamp: '2026-08-26T11:05:00Z',
    timeFormatted: '11:05 AM',
    group: 'YESTERDAY',
    hasDrilldown: false,
    metadata: {
      pair: 'GBP/USD',
      rate: 1.25,
      details: 'Market quote crossed upper band threshold 1.2500',
    },
  },
  {
    id: 'act_05',
    userId: 'usr_yamoo_994821',
    type: 'SECURITY_SETTING_CHANGED',
    category: 'SECURITY',
    title: 'Security Settings',
    subtitle: 'Two-factor auth updated',
    resultFormatted: undefined,
    timestamp: '2026-08-26T09:40:00Z',
    timeFormatted: '09:40 AM',
    group: 'YESTERDAY',
    hasDrilldown: true,
    metadata: {
      details: 'Configured TOTP Authenticator application & updated backup recovery tokens',
    },
  },
  // EARLIER
  {
    id: 'act_06',
    userId: 'usr_yamoo_994821',
    type: 'CURRENCY_CONVERSION',
    category: 'CALCULATIONS',
    title: 'Currency Conversion',
    subtitle: 'EUR to JPY (Wholesale ECB)',
    resultFormatted: 'EUR 1,000 → JPY 162,450',
    timestamp: '2026-08-24T14:10:00Z',
    timeFormatted: 'Aug 24',
    group: 'EARLIER',
    hasDrilldown: false,
    metadata: {
      pair: 'EUR/JPY',
      rate: 162.45,
      amount: 1000,
    },
  },
  {
    id: 'act_07',
    userId: 'usr_yamoo_994821',
    type: 'SAVED_CALCULATION',
    category: 'CALCULATIONS',
    title: 'Saved Calculation',
    subtitle: 'Pinned "US → India Remittance $2,000"',
    resultFormatted: 'Saved',
    timestamp: '2026-08-22T10:00:00Z',
    timeFormatted: 'Aug 22',
    group: 'EARLIER',
    hasDrilldown: true,
    metadata: {
      toolId: 'money-transfers',
      details: 'Wise vs Remitly remittance corridor estimate',
    },
  },
  {
    id: 'act_08',
    userId: 'usr_yamoo_994821',
    type: 'DEVELOPER_API_ACTIVITY',
    category: 'DEVELOPER',
    title: 'Developer API Request',
    subtitle: 'GET /v1/rates/live • 200 OK',
    resultFormatted: '32ms',
    timestamp: '2026-08-21T18:45:00Z',
    timeFormatted: 'Aug 21',
    group: 'EARLIER',
    hasDrilldown: true,
    metadata: {
      statusCode: 200,
      latencyMs: 32,
      details: 'ApiKey yamoo_live_*** requested rates for 32 fiat pairs',
    },
  },
  {
    id: 'act_09',
    userId: 'usr_yamoo_994821',
    type: 'SECURITY_SETTING_CHANGED',
    category: 'SECURITY',
    title: 'Security Settings',
    subtitle: 'Registered FIDO2 Passkey: MacBook Touch ID',
    resultFormatted: undefined,
    timestamp: '2026-08-20T12:30:00Z',
    timeFormatted: 'Aug 20',
    group: 'EARLIER',
    hasDrilldown: true,
    metadata: {
      details: 'WebAuthn hardware cryptographic authenticator registered',
    },
  },
  {
    id: 'act_10',
    userId: 'usr_yamoo_994821',
    type: 'FX_ALERT_TRIGGERED',
    category: 'ALERTS',
    title: 'FX Alert Triggered',
    subtitle: 'EUR/USD threshold crossed',
    resultFormatted: '1.0850',
    timestamp: '2026-08-19T08:00:00Z',
    timeFormatted: 'Aug 19',
    group: 'EARLIER',
    hasDrilldown: false,
    metadata: {
      pair: 'EUR/USD',
      rate: 1.085,
      details: 'Market rate reached 1.0850 target',
    },
  },
];

export const INITIAL_FINANCIAL_SCENARIOS: FinancialScenario[] = [
  {
    id: 'scen_01_relocation',
    userId: 'usr_yamoo_994821',
    title: 'San Francisco Tech Relocation & Mortgage',
    description: 'Comparing gross-to-net salary in California vs $750k home purchase mortgage schedule',
    category: 'INTERNATIONAL_MOVE',
    items: [
      {
        id: 'calc_sal_01',
        title: 'Senior Staff Engineer — California $220,000 W-2',
        toolId: 'salary-engine',
        toolName: 'Salary & Paycheck Calculator',
        timestamp: 1787133600000,
        primaryResult: '$12,410 / month',
        subtitle: 'California $220,000 W-2',
        inputsSummary: 'Single filer • Standard Deduction • 2026 IRS',
        region: 'US',
        createdAt: '2026-08-20T10:00:00Z',
        summary: 'Net Monthly: $12,410 | Federal Tax: $38,420 | CA State Tax: $16,840 | Social: $11,920',
      },
      {
        id: 'calc_loan_01',
        title: 'SF Bay Area Mortgage — $750,000 Purchase / 20% Down / 6.25%',
        toolId: 'loan-engine',
        toolName: 'Mortgage & Loan Calculator',
        timestamp: 1787323800000,
        primaryResult: '$3,694.20 / month',
        subtitle: '$750,000 Purchase / 20% Down',
        inputsSummary: '30-Year Fixed • Monthly Compounding • PITI',
        region: 'US',
        createdAt: '2026-08-22T14:30:00Z',
        summary: 'P&I Monthly: $3,694.20 | PITI Housing Total: $4,820.00/mo | APR: 6.38%',
      },
    ],
    createdAt: '2026-08-20T10:00:00Z',
    updatedAt: '2026-08-22T14:30:00Z',
  },
  {
    id: 'scen_02_remittance',
    userId: 'usr_yamoo_994821',
    title: 'Monthly Family Transfer to India & Euro Corridor',
    description: 'Monitoring Wise vs Remitly for $2,000 USD → INR transfers',
    category: 'TRANSFER',
    items: [
      {
        id: 'calc_trf_01',
        title: 'US → India Remittance $2,000 USD → INR',
        toolId: 'money-transfers',
        toolName: 'Money Transfer Comparison',
        timestamp: 1786958100000,
        primaryResult: '₹167,420 INR',
        subtitle: '$2,000 USD → INR',
        inputsSummary: 'Mid-Market Rate: 83.71 INR per USD',
        region: 'Global',
        createdAt: '2026-08-18T09:15:00Z',
        summary: 'Wise: ₹167,420 (Fee: $5.20) | Remitly: ₹166,800 (Fee: $0.00) | Recipient Difference: +₹620',
      },
    ],
    createdAt: '2026-08-18T09:15:00Z',
    updatedAt: '2026-08-18T09:15:00Z',
  },
];

export const INITIAL_FAVORITES: UserFavoriteItem[] = [
  {
    id: 'fav_curr_01',
    userId: 'usr_yamoo_994821',
    type: 'CURRENCY_PAIR',
    targetId: 'EUR-USD',
    label: 'EUR / USD',
    sublabel: 'Euro to US Dollar Mid-Market Rate',
    addedAt: '2026-02-10T00:00:00Z',
  },
  {
    id: 'fav_curr_02',
    userId: 'usr_yamoo_994821',
    type: 'CURRENCY_PAIR',
    targetId: 'USD-INR',
    label: 'USD / INR',
    sublabel: 'US Dollar to Indian Rupee',
    addedAt: '2026-02-12T00:00:00Z',
  },
  {
    id: 'fav_corr_01',
    userId: 'usr_yamoo_994821',
    type: 'CORRIDOR',
    targetId: 'US-IN',
    label: 'United States → India',
    sublabel: '$2,000 monthly remittance corridor',
    addedAt: '2026-03-01T00:00:00Z',
  },
  {
    id: 'fav_tool_01',
    userId: 'usr_yamoo_994821',
    type: 'TOOL',
    targetId: 'salary-engine',
    label: 'Salary & Income Tax Engine',
    sublabel: '2026 Versioned Tax Packs (US, FR, CA, UK, DE)',
    addedAt: '2026-01-20T00:00:00Z',
  },
];

export const INITIAL_ALERTS: GlobalAlert[] = [
  {
    id: 'alert_01',
    userId: 'usr_yamoo_994821',
    type: 'EXCHANGE_RATE',
    targetPairOrCorridor: 'EUR/USD',
    targetThreshold: 1.1200,
    currentVal: 1.0942,
    condition: 'ABOVE',
    status: 'ACTIVE',
    channel: 'IN_APP',
    createdAt: '2026-08-10T12:00:00Z',
    lastEvaluatedAt: '2026-08-24T14:00:00Z',
  },
  {
    id: 'alert_02',
    userId: 'usr_yamoo_994821',
    type: 'TRANSFER_QUOTE',
    targetPairOrCorridor: 'US → India ($2,000 USD)',
    targetThreshold: 168000,
    currentVal: 167420,
    condition: 'ABOVE',
    status: 'ACTIVE',
    channel: 'EMAIL',
    createdAt: '2026-08-15T09:00:00Z',
    lastEvaluatedAt: '2026-08-24T14:00:00Z',
  },
  {
    id: 'alert_03',
    userId: 'usr_yamoo_994821',
    type: 'TAX_RULE_UPDATE',
    targetPairOrCorridor: 'France Code Général des Impôts (2026)',
    targetThreshold: 0,
    currentVal: 0,
    condition: 'ANY_CHANGE',
    status: 'ACTIVE',
    channel: 'IN_APP',
    createdAt: '2026-07-01T10:00:00Z',
    lastEvaluatedAt: '2026-08-24T14:00:00Z',
  },
];

export const INITIAL_NOTIFICATIONS: NotificationItem[] = [
  {
    id: 'notif_01',
    userId: 'usr_yamoo_994821',
    category: 'SECURITY',
    title: 'New Passkey Authentication',
    body: 'Your account was signed in using Passkey "MacBook Pro M3 (Touch ID)" from San Francisco, US.',
    read: false,
    timestamp: '2026-08-24T08:00:00Z',
    linkView: 'my-yamoopay',
  },
  {
    id: 'notif_02',
    userId: 'usr_yamoo_994821',
    category: 'FINANCIAL_ALERT',
    title: 'Wise Rate Update: USD → INR',
    body: 'Wise rate updated to 1 USD = 83.71 INR (+0.4% from yesterday). Your ₹167,420 recipient quote is fresh.',
    read: false,
    timestamp: '2026-08-23T14:00:00Z',
    linkView: 'money-transfers',
  },
  {
    id: 'notif_03',
    userId: 'usr_yamoo_994821',
    category: 'PRODUCT',
    title: 'Prompt 07 Global Loans & Mortgages Engine Released',
    body: 'YamooPay now features sovereign loan compounding, PITI housing breakdown, and Canadian semi-annual amortization.',
    read: true,
    timestamp: '2026-08-20T10:00:00Z',
    linkView: 'loan-engine',
  },
];

export const INITIAL_NOTIFICATION_PREFERENCES: NotificationPreference = {
  userId: 'usr_yamoo_994821',
  securityEmail: true,
  financialAlerts: true,
  productUpdates: false,
  quietHoursEnabled: true,
  quietHoursStart: '22:00',
  quietHoursEnd: '08:00',
  pushEnabled: true,
};

export const INITIAL_PRIVACY_PREFERENCES: PrivacyPreference = {
  userId: 'usr_yamoo_994821',
  autoSaveHistory: true,
  personalizationEnabled: true,
  analyticsConsent: false,
  marketingConsent: false,
  sessionReplayMasking: true,
};

export const INITIAL_CONSENT_RECORDS: ConsentRecord[] = [
  {
    id: 'consent_01',
    userId: 'usr_yamoo_994821',
    purpose: 'Core Application Service & Saved Calculations',
    version: '2026.1',
    status: 'GRANTED',
    timestamp: '2026-01-15T10:24:00Z',
    jurisdiction: 'EU GDPR / US CCPA',
  },
  {
    id: 'consent_02',
    userId: 'usr_yamoo_994821',
    purpose: 'Anonymous Usage Diagnostics (Opt-Out Default)',
    version: '2026.1',
    status: 'REVOKED',
    timestamp: '2026-01-15T10:24:00Z',
    jurisdiction: 'EU GDPR / US CCPA',
  },
];

export const RBAC_PERMISSIONS_MATRIX: RbacPermission[] = [
  { code: 'users.read_limited', category: 'User Management', description: 'View redacted user profiles & account statuses', sensitive: false },
  { code: 'users.security_manage', category: 'User Security', description: 'Revoke active user sessions or reset recovery factors', sensitive: true },
  { code: 'tax_rules.edit', category: 'Financial Governance', description: 'Draft new versioned salary tax packs & brackets', sensitive: false },
  { code: 'tax_rules.approve', category: 'Financial Governance', description: 'Approve & promote tax rulesets to production (4-Eyes principle)', sensitive: true },
  { code: 'fx_sources.manage', category: 'Financial Governance', description: 'Configure central bank & ECB/FED data feeds', sensitive: false },
  { code: 'content.publish', category: 'Content & SEO', description: 'Publish verified financial articles & country guides', sensitive: false },
  { code: 'roles.assign', category: 'Access Control', description: 'Assign internal staff roles & permissions', sensitive: true },
  { code: 'audit.read', category: 'Compliance & Audit', description: 'Export & inspect immutable system security logs', sensitive: true },
];

export const INITIAL_ROLE_ASSIGNMENTS: RoleAssignment[] = [
  {
    id: 'ra_01',
    userEmail: 'alexandre.dubois@yamoopay.com',
    userName: 'Alexandre Dubois',
    role: 'SuperAdmin',
    assignedAt: '2026-01-01T00:00:00Z',
    assignedBy: 'System Bootstrap',
    department: 'Executive Security & Identity',
  },
  {
    id: 'ra_02',
    userEmail: 'charlotte.moreau@yamoopay.com',
    userName: 'Charlotte Moreau',
    role: 'FinancialDataReviewer',
    assignedAt: '2026-02-15T10:00:00Z',
    assignedBy: 'alexandre.dubois@yamoopay.com',
    department: 'Global Tax & Regulatory Compliance',
  },
  {
    id: 'ra_03',
    userEmail: 'support.lead@yamoopay.com',
    userName: 'David Miller',
    role: 'SupportAgent',
    assignedAt: '2026-03-01T08:30:00Z',
    assignedBy: 'alexandre.dubois@yamoopay.com',
    department: 'Customer Care & Verification',
  },
];

export const INITIAL_ADMIN_AUDIT_LOGS: AdminAuditLogEntry[] = [
  {
    id: 'audit_01',
    actorEmail: 'alexandre.dubois@yamoopay.com',
    action: 'ROLE_ASSIGNED',
    targetResource: 'RoleAssignment: charlotte.moreau@yamoopay.com',
    details: 'Granted FinancialDataReviewer role to Charlotte Moreau (4-Eyes approval power for 2026 Tax Rules)',
    timestamp: '2026-02-15T10:00:00Z',
    ip: '198.51.100.42',
  },
  {
    id: 'audit_02',
    actorEmail: 'charlotte.moreau@yamoopay.com',
    action: 'TAX_RULESET_APPROVED',
    targetResource: 'RuleSet: France CGI 2026 (rule_fr_2026_v1)',
    details: 'Approved 2026 French income tax brackets & CSG/CRDS social contribution ruleset after dual verification',
    timestamp: '2026-03-01T14:22:00Z',
    ip: '192.0.2.14',
  },
];

export const INITIAL_TELEMETRY: IdentityTelemetry = {
  totalUsers: 148290,
  passkeyAdoptionPct: 68.4,
  activeSessionsCount: 19482,
  socialSignInsPct: 24.1,
  failedAuthRate24h: 0.12,
  suspiciousEventsCount: 3,
  pendingExportsCount: 0,
  securityIncidentsCount: 0,
};

export const DELIVERABLES_P8: DeliverableP8[] = [
  {
    code: 'ID-01',
    titleEn: 'Passkey-First WebAuthn Authentication Engine',
    titleFr: 'Moteur d’Authentification Passkey-First WebAuthn',
    category: 'Identity & Passkey Architecture',
    summary: 'Enables passwordless registration & sign-in leveraging hardware authenticators (Touch ID, Face ID, Windows Hello, YubiKey). Stores zero biometric or device secrets on YamooPay servers.',
    details: [
      'WebAuthn credential creation & assertion with cryptographically unique single-use challenge verification',
      'RP ID domain validation and client-side device name labeling without invasive hardware profiling',
      'Multi-passkey registration support to eliminate single-point-of-failure lockouts',
      'Passkey status management (Active, Revoked, Last Used timestamp logging)',
    ],
    architectureNotes: 'Adheres to FIDO2 / W3C WebAuthn standards with full fallback to OIDC & Magic Links.',
  },
  {
    code: 'ID-02',
    titleEn: 'Federated OIDC Social Login & Email Magic Link Fallback',
    titleFr: 'Connexion Sociale Fédérée OIDC & Magic Link Email',
    category: 'OIDC, Social & Passwordless Engine',
    summary: 'Standards-compliant OpenID Connect integrations for Google, Apple, and Microsoft alongside high-entropy single-use email Magic Links.',
    details: [
      'Authorization Code Flow with PKCE (S256 challenge validation) preventing code interception',
      'Strict OpenID Connect token validation (issuer, audience, nonce, expiration, signature verification)',
      'Single-use, expiring Magic Links stored server-side with anti-replay protections',
      'No account enumeration leakage on public email login interfaces',
    ],
    architectureNotes: 'Strictly separates authentication from authorization; treats issuer + subject as canonical account identity.',
  },
  {
    code: 'ID-03',
    titleEn: 'Server-Controlled Session Management & Step-Up Sudo Mode',
    titleFr: 'Gestion de Session Serveur & Mode Sudo Élevé (Step-Up)',
    category: 'Session Security & Step-Up Sudo Mode',
    summary: 'Opaque server-persisted sessions with location metadata, active device lists, remote session revocation, and step-up sudo verification for sensitive operations.',
    details: [
      'Opaque session tokens delivered via HttpOnly, Secure, SameSite cookies with no sensitive JWT secrets in localStorage',
      'Active session dashboard displaying approximate region, browser, IP, and one-click remote session revocation',
      'Recent Authentication (Sudo Mode) mandatory window required prior to security setting changes, data export, or account deletion',
      'Comprehensive AccountSecurityEvent audit trail capturing sign-ins, passkey changes, and session revocations',
    ],
    architectureNotes: 'Prevents session fixation and provides immediate global logout capabilities across all active devices.',
  },
  {
    code: 'ID-04',
    titleEn: 'My YamooPay Workspace, Saved Calculations & Financial Scenarios',
    titleFr: 'Espace Personnel My YamooPay, Calculs Sauvegardés & Scénarios',
    category: 'My YamooPay Workspace & Scenarios',
    summary: 'Personal financial workspace allowing users to organize calculations into scenarios (e.g., SF Relocation, Home Purchase), manage favorites, and sync seamlessly across devices.',
    details: [
      'No Account Wall: Core tools remain 100% functional for anonymous guest visitors',
      'Contextual Save CTAs prompting users to save outputs to My YamooPay with zero lost calculator state',
      'Financial Scenarios grouping multiple calculation models (Salary + Tax + Mortgage) under unified assumption sets',
      'Idempotent Guest-to-Account Migration workflow transferring local browser state into verified account cloud storage',
    ],
    architectureNotes: 'Maintains calculation immutability by storing original formula versions alongside current recalculation options.',
  },
  {
    code: 'ID-05',
    titleEn: 'Global Alerts & In-App / Push Notification Center',
    titleFr: 'Centre d’Alertes Mondiales & Notifications In-App / Push',
    category: 'Alerts, Notifications & Push Engine',
    summary: 'Real-time alert monitoring for exchange rates, remittance quotes, and tax rule updates with user-configurable quiet hours and delivery channels.',
    details: [
      'Exchange Rate & Transfer Corridor threshold alerts evaluated against official FX and provider quote feeds',
      'Multi-channel delivery (In-App Notification Inbox, Verified Email, Web Push notifications)',
      'Granular Notification Preferences with Quiet Hours protection preventing non-critical nightly alerts',
      'Critical Security Notifications (new sign-ins, passkey removals) prioritized above user quiet hours',
    ],
    architectureNotes: 'Protects user attention with rate-limiting and deduplication algorithms.',
  },
  {
    code: 'ID-06',
    titleEn: 'Privacy Center, Consent Management & Self-Serve Data Export / Deletion',
    titleFr: 'Centre de Confidentialité, Gestion des Consentements & Export / Suppression',
    category: 'Privacy Center, Consent & Data Control',
    summary: 'GDPR / CCPA compliant Privacy Center offering self-serve JSON data exports, account deletion workflows, versioned consent records, and strict advertising isolation.',
    details: [
      'Download My Data: Instant machine-readable JSON archive export containing profiles, saved calculations, and scenarios',
      'Delete My YamooPay Account: Transparent self-serve deletion workflow with immediate session revocation',
      'Zero Financial Profiling for Ads: Strictly forbids passing salary, mortgage, or financial inputs to advertising trackers',
      'Versioned Consent Records tracking user consent status across core services and optional analytics',
    ],
    architectureNotes: 'Privacy-by-default architecture ensuring raw calculation state never leaks to external ad networks.',
  },
  {
    code: 'ID-07',
    titleEn: 'Internal Role-Based Access Control (RBAC) & Security Command Center',
    titleFr: 'Contrôle d’Accès Basé sur les Rôles (RBAC) & Command Center Sécurité',
    category: 'Internal RBAC & Identity Command Center',
    summary: 'Granular administrative role hierarchy (SupportAgent, FinancialDataReviewer, SuperAdmin) enforcing the Four-Eyes principle, audit logging, and security telemetry.',
    details: [
      'Fine-grained permission matrix separating operational support viewing from tax rule production approval',
      'Four-Eyes Principle: Mandates dual approval before promoting financial rulesets or changing security roles',
      'Admin Audit Log capturing every role assignment, rule approval, and administrative intervention',
      'Real-time Identity Telemetry monitoring passkey adoption rates, active session counts, and auth error rates',
    ],
    architectureNotes: 'Eliminates simplistic boolean `isAdmin` checks in favor of server-enforced, audited RBAC permission checks.',
  },
];
